export const WORK_EXPERIENCE_PATH = '/work-experience';
export const WORK_EXPERIENCE_LEAD_PATH = '/work-experience/lead';
export const WORK_EXPERIENCE_FORM_ID = 'work-experience-first-instincts';
export const WORK_EXPERIENCE_FORM_PASSWORD = 'first-instincts';
export const WORK_EXPERIENCE_STORAGE_KEY = 'overhear.workExperienceWorksheet.v1';

export function normalisePublicPath(pathname: string): string {
  return pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
}

export function isWorkExperiencePublicPath(pathname: string): boolean {
  const path = normalisePublicPath(pathname);
  return path === WORK_EXPERIENCE_PATH || path === WORK_EXPERIENCE_LEAD_PATH;
}

export function worksheetDownloadName(name: string | undefined): string {
  const slug = (name ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  return slug ? `overhear-first-instincts-${slug}.txt` : 'overhear-first-instincts.txt';
}
